import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";
import { useQueryClient } from '@tanstack/react-query';
// @YUp
import * as Yup from "yup";
import { Button, Grid, TextField, FormControl, MenuItem, Select, FormHelperText } from "@mui/material";
import API from "../../utils/Axios.utils";
import { Notification } from "../../utils/Notification";
import FIelds from "../../uicomponents/FIelds";
import TextArea from "../../uicomponents/TextArea";
import CustomSelect from "../../uicomponents/CustomSelect";
import CustomMultiSelect from "../../uicomponents/CustomMultiSelect";
import TextEditor from "../../utils/TextEditor";
import useAuth from "../../hooks/useAuth";

const AddJob = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [isFormSubmitted, setIsFormSubmitted] = React.useState(false);

  // Snackbar
  const [alert, setAlert] = React.useState(false);
  const [alertContent, setAlertContent] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  const handleAlert = () => {
    setAlert(false);
  };

  const [editorContent, setEditorContent] = React.useState("");
  const [clearData, setClearData] = React.useState(false);
  // For Validation
  const [editorIsEmpty, setEditorIsEmpty] = React.useState(false);

  // Skill Data
  const [skillData, setSkillData] = useState([]);

  const handleEditorEmptyChange = (isEmpty) => {
    setEditorIsEmpty(isEmpty);
  };
  // validation code end

  const handleContentChange = (content) => {
    // Handle the editor content here (e.g., store it in state)
    setEditorContent(content);
  };

  // const handleClearButtonClick = () => {
  //   // Set clearData to true to clear the editor's content
  //   setClearData(true);
  // };

  const initialValues = {
    title: "",
    location: "",
    experience: "",
    currency: "",
    budget: "",
    budget_uom: "",
    mode_of_work: "",
    notice_period: "",
    // primary_skills: "",
    job_description: "",
    status: "",
    notes: "",
    coreSkillId: "",      // NEW
    techSkills: [],
    customer_id: '',
    no_of_requirements: 1,
    fulfilled_count: 0,
    contact_id: '',
    background_verification: 'No',
    assignment_duration_days: 90,
  };

  const { token } = useAuth();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  // const onSubmit = async (values) => {
  //   setIsFormSubmitted(true);
  //   if (editorIsEmpty) {
  //     // setIsFormSubmitted(true);
  //     return;
  //   } else {
  //     values.job_description = editorContent;
  //     try {
  //       const res = await API.post("/api/job/addjob", values, config);
  //       setAlertContent(res?.data?.message);
  //       setAlertType("success");
  //       setAlert(true);
  //       setTimeout(() => {
  //         navigate("/jobs");
  //       }, 1500);
  //     } catch (error) {
  //       setAlertContent(error?.response?.data?.message);
  //       setAlertType("error");
  //       setAlert(true);
  //     }
  //   }
  // };

  const onSubmit = async (values) => {
    setIsFormSubmitted(true);
    if (editorIsEmpty || !editorContent || !editorContent.trim()) {
      return;
    } else {
      const locationsArray = values.locations
        ? values.locations.split(',').map(loc => loc.trim()).filter(loc => loc)
        : [];
      values.job_description = editorContent;

      const payload = {
        ...values,
        background_verification: values.background_verification ? 'Yes' : 'No',
        location: locationsArray,  // ✅ Sends: ["Pune", "Mumbai"]
        job_description: editorContent,
      };

      // delete payload.location;
      try {
        const res = await API.post("/api/job/addjob", payload, config);

        const { message, showAlert, alertType, fulfillment } = res?.data || {};

        // Build final message for Notification
        let finalMessage = message || "Job created successfully.";
        if (showAlert && alertType === "FULL_FILLED" && fulfillment) {
          finalMessage = `${message} All ${fulfillment.total} positions are filled.`;
        }

        setAlertContent(finalMessage);
        setAlertType("success");
        setAlert(true);

        // Invalidate React Query cache to refresh job list
        queryClient.invalidateQueries({ queryKey: ['jobs'] });

        setTimeout(() => {
          navigate("/jobs");
        }, 1500);
      } catch (error) {
        setAlertContent(error?.response?.data?.message || "Something went wrong");
        setAlertType("error");
        setAlert(true);
      }
    }
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required("Job title is required.")
      .min(2, "Minimum 2 characters are required.")
      .max(100, "Maximum length is 100 characters.")
      .test(
        "no-empty-or-spaces",
        "Title must not be empty or contain only spaces.",
        (value) => value?.trim().length > 0
      )
      .test(
        "no-leading-trailing-spaces",
        "Leading and trailing spaces are not allowed.",
        (value) => value === value?.trim()
      )
      .matches(
        /^[a-zA-Z0-9.,#\-_ ]+$/,
        "Please use only letters, numbers, spaces, and symbols: . , # - _"
      ),
    // location: Yup.string()
    //   .min(2, "Minimum 2 characters is required.")
    //   .max(50, "Maximum length is 100 characters.")
    //   .matches(
    //     /^[a-zA-Z]+(\s[a-zA-Z]+)*$/,
    //     "Invalid Location format.Spaces at the start and end are not allowed."
    //   )
    //   .required("This field is required."),
    locations: Yup.string()
      .required("Location is required")
      .test("valid-locations", "Invalid location format", function (value) {
        if (!value?.trim()) return false;

        // ✅ Split and validate each location using OLD regex
        const locations = value.split(',').map(loc => loc.trim()).filter(Boolean);

        // Check each location matches old regex pattern
        const locationRegex = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;
        const isValid = locations.every(loc =>
          loc.length >= 2 &&
          loc.length <= 50 &&
          locationRegex.test(loc)
        );

        return isValid && locations.length > 0;
      }),
    experience: Yup.string()
      .min(1, "Minimum 1 character is required.")
      .max(4, "Maximum length is 4 characters.")
      .required("This field is required."),
    currency: Yup.string().required("This field is required."),
    budget: Yup.string().required("This field is required."),
    budget_uom: Yup.string().required("This field is required."),
    mode_of_work: Yup.string().required("This field is required."),
    notice_period: Yup.string()
      .min(1, "Minimum 1 character is required.")
      .max(2, "Maximum length is 2 characters.")
      .required("This field is required."),
    assignment_duration_days: Yup.number()
      .min(1, "Minimum 1 day")
      .max(3650, "Maximum 10 years (3650 days)")
      .required("Assignment duration is required"),
    // job_description: Yup.string()
    //   .min(2, "Minimum 2 character is required.")
    //   .max(100, "Maximum length is 100 characters.")
    //   .required("This field is required."),
    status: Yup.string().required("This field is required."),
    notes: Yup.string()
      .min(2, "Minimum 2 characters is required.")
      .max(255, "Maximum length is 255 characters.")
      .notRequired(),
    // .required("This field is required."),
    // primary_skills: Yup.array().required("This field is required."),
    coreSkillId: Yup.number()
      .typeError("This field is required.")
      .required("This field is required."),
    techSkills: Yup.array().required("This field is required."),
    customer_id: Yup.number()
      .typeError("This field is required")
      .required("Customer is required"),
    contact_id: Yup.number()
      .nullable()
      .when("customer_id", {
        is: (customer_id) => customer_id,
        then: (schema) => schema.required("Contact person is required"),
        otherwise: (schema) => schema.notRequired()
      }),
    no_of_requirements: Yup.number()
      .min(1, "Minimum 1 requirement")
      .required("No. of requirements is required"),
    contact_person_name: Yup.string().max(50, "Max 50 characters"),
    contact_person_number: Yup.string()
      .matches(/^[\+]?[1-9][\d]{0,15}$/, "Invalid phone number"),
    contact_person_email: Yup.string().email("Invalid email"),
    fulfilled_count: Yup.number()
      .min(0, "Cannot be negative")
      .when("status", {
        is: (val) => ["Partially-Fulfilled", "Full-Filled"].includes(val),
        then: (schema) =>
          schema
            .required("Filled positions required for this status")
            .test(
              "not-greater-than-req",
              "Filled positions cannot exceed total requirements",
              function (value) {
                const { no_of_requirements } = this.parent;
                if (!no_of_requirements) return true;
                if (value == null) return false;
                return value <= no_of_requirements;
              }
            ),
        otherwise: (schema) => schema.notRequired(),
      }),
    background_verification: Yup.string().oneOf(['Yes', 'No']).notRequired(),
  });
  const [coreSkills, setCoreSkills] = useState([]);

  const [techSkills, setTechSkills] = useState([]);

  const [customers, setCustomers] = useState([]);
  const [customerContacts, setCustomerContacts] = useState([]);

  const getCoreSkills = async () => {
    try {
      const res = await API.get(
        "/api/core-skill/coreSkills",
        config
      );
      const formattedCore = res?.data?.coreSkills?.map((item) => ({
        id: item.id,
        value: item.id,
        label: item.name,
      }));
      setCoreSkills(formattedCore);
    } catch (error) {
      console.log("getCoreSkills error", error);
    }
  };

  const getTechSkillsByCore = async (coreSkillId) => {

    if (!coreSkillId) {
      setTechSkills([]);
      return;
    }
    try {
      const res = await API.get(
        `/api/tech-skill/alltechSkills/${coreSkillId}`,
        config
      );
      const formattedTech = res?.data?.techSkills?.map((item) => ({
        id: item.id,
        value: item.name,
        label: item.name,
      }));
      const allSkillsOption = [{
        id: 'all',
        value: 'All Skills',
        label: 'All Skills'
      }];
      setTechSkills([...allSkillsOption, ...formattedTech]);
      setTechSkills(formattedTech);
    } catch (error) {
      console.log("getTechSkillsByCore error", error);
    }
  };
  // useEffect(()=>{
  //   getTechSkillsByCore(coreSkillId);
  // },[coreSkillId])
  const getSkills = async () => {
    let url = `/api/skill/skill_list`;

    try {
      const res = await API.get(url, config);
      const formattedSkills = res?.data?.skill?.map((skill) => ({
        id: skill.skill_id,
        value: skill.skill_name,
        label: skill.skill_name,
      }));
      setSkillData(formattedSkills);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getCustomers = async () => {
    try {
      const res = await API.get('/api/customer/active_customer_list', config);
      const formattedCustomers = res?.data?.customers?.map(item => ({
        id: item.customer_id,
        value: item.customer_id,
        label: `${item.name}`,
        customer_code: item.customer_code,
        name: item.name
      }));
      setCustomers(formattedCustomers);
    } catch (error) {
      console.log('getCustomers error:', error);
    }
  };
  const getCustomerContacts = async (customerId) => {
    if (!customerId) {
      setCustomerContacts([]);
      // setFieldValue('contact_id', ''); // Reset in formik
      return;
    }

    try {
      const res = await API.get(`/api/customer/CustomersContacts/${customerId}`, config);
      const formattedContacts = res?.data?.contacts?.map(item => ({
        id: item.contact_id,
        value: item.contact_id,
        label: `${item.name || 'N/A'}`,
        name: item.name,
        email: item.email,
        phone: item.phone
      })) || [];
      setCustomerContacts(formattedContacts);
    } catch (error) {
      console.log('getCustomerContacts error', error);
      setCustomerContacts([]);
    }
  };
  useEffect(() => {
    getSkills();
    getCoreSkills();
    getCustomers();
  }, []);

  const navigateToPreviousPage = () => {
    navigate(-1);
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
        Back
      </Button>
      <div
        style={{
          border: "1px solid #989898",
          borderRadius: "10px",
          padding: "15px",
        }}
      >
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontSize: "20px",
            fontWeight: "500",
            letterSpacing: 1,
            textAlign: "left",
          }}
        >
          <span>Create Job</span>
          <div style={{ display: "grid" }}>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
              validateOnMount={true}
            >
              {(props) => (
                <Form noValidate>
                  <Grid container spacing={2}>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Job Title <span style={{ color: 'red' }}>*</span></span>

                      <Field
                        as={TextField}
                        name="title"
                        fullWidth
                        error={props.errors.title && props.touched.title}
                        size="small"
                        helperText={<ErrorMessage name="title" />}
                        required
                      />
                    </Grid>
                    {/* Customer Dropdown - ADD THIS BEFORE Currency */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>Customer <span style={{ color: 'red' }}>*</span></span>
                      <Field name="customer_id" >
                        {({ field, form }) => (
                          <FormControl fullWidth variant="outlined" size="small" error={form.touched.customer_id && Boolean(form.errors.customer_id)}>
                            <Select
                              {...field}
                              // onChange={(event) => {
                              //   const value = event.target.value;
                              //   form.setFieldValue('customer_id', value);
                              // }}
                              onChange={(event) => {
                                const value = event.target.value;
                                form.setFieldValue('customer_id', value);
                                getCustomerContacts(value);  // ✅ NEW: Fetch contacts
                                form.setFieldValue('contact_id', ''); // ✅ Reset contact
                              }}
                              displayEmpty
                            >
                              {customers.map((option) => (
                                <MenuItem key={option.id} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText sx={{ color: 'red' }}>
                              <ErrorMessage name="customer_id" />
                            </FormHelperText>
                          </FormControl>
                        )}
                      </Field>
                    </Grid>
                    {/* ✅ ADD CONTACT PERSON DROPDOWN - AFTER Customer Grid */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>
                        Contact Person <span style={{ color: 'red' }}>*</span>
                      </span>
                      <Field name="contact_id">
                        {({ field, form }) => (
                          <FormControl
                            fullWidth
                            variant="outlined"
                            size="small"
                            error={form.touched.contact_id && Boolean(form.errors.contact_id)}>
                            <Select
                              {...field}
                              value={field.value || ''}
                              onChange={(event) => {
                                const value = event.target.value;
                                form.setFieldValue('contact_id', value);
                              }}
                              displayEmpty>
                              {/* <MenuItem value="">
                                <em>{props.values.customer_id ? 'Select Contact Person' : 'First select customer'}</em>
                              </MenuItem> */}
                              {customerContacts.map((option) => (
                                <MenuItem key={option.id} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText sx={{ color: 'red' }}>
                              <ErrorMessage name="contact_id" />
                            </FormHelperText>
                          </FormControl>
                        )}
                      </Field>
                    </Grid>
                    {/* Location */}
                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Location</span>
                      <FIelds name="location" props={props} />
                    </Grid> */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>
                        Locations <span style={{ color: 'red' }}>*</span>
                      </span>
                      <Field name="locations">
                        {({ field, form, meta }) => {
                          // ✅ Convert for preview
                          const locationArray = field.value
                            ? field.value.split(',').map(loc => loc.trim()).filter(Boolean)
                            : [];

                          return (
                            <>
                              <TextField
                                {...field}
                                fullWidth
                                error={meta.touched && meta.error}
                                size="small"
                                helperText={
                                  meta.touched && meta.error ? (
                                    <ErrorMessage name="locations" />
                                  ) : (
                                    "Enter multiple locations separated by commas"
                                  )
                                }
                              />
                            </>
                          );
                        }}
                      </Field>
                    </Grid>

                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Experience <span style={{ color: 'red' }}>*</span></span>
                      <FIelds name="experience" props={props} onInput="yes" />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Currency <span style={{ color: 'red' }}>*</span></span>
                      <CustomSelect
                        name="currency"
                        props={props}
                        options={allCurrency}
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Budget <span style={{ color: 'red' }}>*</span></span>
                      <FIelds name="budget" props={props} onInput="yes" />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Budget UOM <span style={{ color: 'red' }}>*</span></span>
                      <CustomSelect
                        name="budget_uom"
                        props={props}
                        options={budgetUOM}
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Work Mode <span style={{ color: 'red' }}>*</span></span>
                      <CustomSelect
                        name="mode_of_work"
                        props={props}
                        options={WorkMode}
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>
                        Timeline (Days) <span style={{ color: 'red' }}>*</span>
                      </span>
                      <FIelds
                        name="notice_period"
                        props={props}
                        onInput="yes"
                      />
                    </Grid>
                    {/* ✅ ADD after Notice Period Grid, before Core Skill */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>
                        Assignment Duration (Days) <span style={{ color: 'red' }}>*</span>
                      </span>
                      <Field
                        as={TextField}
                        name="assignment_duration_days"
                        type="number"
                        fullWidth
                        error={props.errors.assignment_duration_days && props.touched.assignment_duration_days}
                        size="small"
                        helperText={<ErrorMessage name="assignment_duration_days" />}
                        required
                        inputProps={{
                          min: 1,
                          max: 3650,
                          placeholder: "90"
                        }}
                      />
                    </Grid>
                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Primary Skills</span>
                      <CustomMultiSelect
                        name="primary_skills"
                        props={props}
                        options={skillData}
                      />
                    </Grid> */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Core Skill <span style={{ color: 'red' }}>*</span></span>
                      <Field name="coreSkillId">
                        {({ field, form }) => (
                          <FormControl
                            fullWidth
                            variant="outlined"
                            size="small"
                            error={form.touched.coreSkillId && Boolean(form.errors.coreSkillId)}
                          >
                            <Select
                              {...field}
                              onChange={(event) => {
                                const value = event.target.value;
                                form.setFieldValue("coreSkillId", value);
                                form.setFieldValue("techSkills", []); // reset multi-select
                                getTechSkillsByCore(value); // call your fetch function
                              }}
                              displayEmpty
                            >
                              {coreSkills.map((option) => (
                                <MenuItem key={option.id} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText sx={{ color: "red" }}>
                              <ErrorMessage name="coreSkillId" />
                            </FormHelperText>
                          </FormControl>
                        )}
                      </Field>
                    </Grid>
                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Tech Skills</span>
                      <Field name="techSkills">
                        {({ field, form }) => (
                          <FormControl
                            fullWidth
                            variant="outlined"
                            size="small"
                            error={form.touched.techSkills && Boolean(form.errors.techSkills)}
                          >
                            <Select
                              multiple
                              displayEmpty
                              {...field}
                              value={field.value || []}
                              onChange={(event) => {
                                form.setFieldValue("techSkills", event.target.value);
                              }}
                              onBlur={field.onBlur}
                              size="small"
                              variant="outlined"
                            >
                              {techSkills.map((option) => (
                                <MenuItem key={option.id} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText sx={{ color: "red" }}>
                              <ErrorMessage name="techSkills" />
                            </FormHelperText>
                          </FormControl>
                        )}
                      </Field>
                    </Grid> */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Tech Skills</span>
                      <Field name="techSkills">
                        {({ field, form }) => {
                          const handleChange = (event) => {
                            const selectedValues = event.target.value || [];

                            // ✅ "All Skills" LOGIC
                            if (selectedValues.includes('All Skills') ||
                              selectedValues.some(val => val === 'All Skills')) {
                              // Select ALL available tech skills
                              const allTechSkills = techSkills
                                .filter(skill => skill.value !== 'All Skills')
                                .map(skill => skill.value);
                              form.setFieldValue("techSkills", allTechSkills);
                            } else {
                              form.setFieldValue("techSkills", selectedValues);
                            }
                          };

                          return (
                            <FormControl
                              fullWidth
                              variant="outlined"
                              size="small"
                              error={form.touched.techSkills && Boolean(form.errors.techSkills)}
                            >
                              <Select
                                multiple
                                displayEmpty
                                {...field}
                                value={field.value || []}
                                onChange={handleChange}  // ✅ Updated handler
                                onBlur={field.onBlur}
                                size="small"
                                variant="outlined"

                                renderValue={(selected) => (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 6,
                                      maxHeight: 60,        // ✅ Prevents stretching
                                      overflowY: "auto"     // ✅ Scroll instead of grow
                                    }}
                                  >
                                    {selected.map((value) => (
                                      <span
                                        key={value}
                                        style={{
                                          background: "#E3F2FD",
                                          padding: "4px 8px",
                                          borderRadius: 12,
                                          fontSize: "13px",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {value}
                                      </span>
                                    ))}
                                  </div>
                                )}
                              >
                                <MenuItem value="All Skills">
                                  All Skills
                                </MenuItem>
                                {techSkills
                                  .filter(skill => skill.value !== 'All Skills')  // ✅ Exclude from list
                                  .map((option) => (
                                    <MenuItem key={option.id} value={option.value}>
                                      {option.label}
                                    </MenuItem>
                                  ))}
                              </Select>
                              <FormHelperText sx={{ color: "red" }}>
                                <ErrorMessage name="techSkills" />
                              </FormHelperText>
                            </FormControl>
                          );
                        }}
                      </Field>
                    </Grid>

                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Status <span style={{ color: 'red' }}>*</span></span>
                      <CustomSelect
                        name="status"
                        props={props}
                        options={allStatus}
                      />
                    </Grid>
                    {/* ✅ ADD BGV CHECKBOX - After Work Mode, before Notice Period */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>BGV</span>
                      <Field name="background_verification">
                        {({ field, form, meta }) => (
                          <FormControl
                            fullWidth
                            error={meta.touched && Boolean(meta.error)}
                            size="small">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <input
                                type="checkbox"
                                checked={field.value == 'Yes'}
                                onChange={(e) => form.setFieldValue('background_verification', e.target.checked ? 'Yes' : 'No')}
                                style={{
                                  width: '18px',
                                  height: '18px',
                                  accentColor: '#2777AA'
                                }}
                              />
                              <span style={{ fontSize: '16px', fontWeight: 500 }}>
                                Background Verification
                              </span>
                            </div>
                            {meta.touched && meta.error && (
                              <FormHelperText sx={{ color: 'red', marginLeft: '26px' }}>
                                {meta.error}
                              </FormHelperText>
                            )}
                          </FormControl>
                        )}
                      </Field>
                    </Grid>

                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>Numbers of Requirements</span>
                      <Field as={TextField}
                        name="no_of_requirements"
                        type="number"
                        fullWidth
                        error={props.errors.no_of_requirements && props.touched.no_of_requirements}
                        size="small"
                        helperText={<ErrorMessage name="no_of_requirements" />}
                        required
                        inputProps={{ min: 1, max: 100 }}
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>Filled Positions</span>
                      <Field
                        as={TextField}
                        name="fulfilled_count"
                        type="number"
                        fullWidth
                        error={props.errors.fulfilled_count && props.touched.fulfilled_count}
                        size="small"
                        helperText={<ErrorMessage name="fulfilled_count" />}
                        inputProps={{ min: 0 }}
                      />
                    </Grid>
                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid> */}
                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid> */}
                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid> */}
                    <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Notes</span>
                      <Field
                        as={TextField}
                        name={"notes"}
                        multiline
                        rows={5}
                        fullWidth

                        size="small"

                      />                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Job Description <span style={{ color: "red" }}>*</span></span>
                      {/* <TextArea TextArea name="job_description" props={props} /> */}
                      <TextEditor
                        getContent={handleContentChange}
                        setClearData={setClearData}
                        clearData={clearData}
                        onEditorEmptyChange={handleEditorEmptyChange}
                      />

                      {isFormSubmitted && editorIsEmpty && (
                        <div
                          style={{
                            color: "#d32f2f",
                            marginLeft: "14px",
                            fontWeight: 400,
                            fontSize: "0.75rem",
                          }}
                        >
                          This Field is required
                        </div>
                      )}
                    </Grid>

                    {/* Submit */}
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          aria-haspopup="true"
                          style={{
                            background: !props.isValid || !editorContent || !editorContent.replace(/<[^>]*>/g, '').trim() ? "#ccc" : "#2777AA",
                            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "16px",
                            fontWeight: "500",
                            letterSpacing: 1,
                          }}
                          type="submit"
                          disabled={!props.isValid || !editorContent || !editorContent.replace(/<[^>]*>/g, '').trim()}
                        >
                          Submit
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                  <Notification
                    message={alertContent}
                    open={alert}
                    severity={alertType}
                    onClose={handleAlert}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddJob;

const WorkMode = [
  { id: 1, value: "remote", label: "Work Remotely" },
  { id: 2, value: "office", label: "Work From Office" },
  { id: 3, value: "hybrid", label: "Hybrid" },
];
const allStatus = [
  { id: 1, value: "Active", label: "Active" },
  { id: 2, value: "Full-Filled", label: "Full-Filled" },
  { id: 3, value: "Critical", label: "Critical" },
  { id: 4, value: "Hold", label: "Hold" },
  { id: 5, value: "Cancelled", label: "Cancelled" },
  { id: 6, value: "Partially-Fulfilled", label: "Partially-Fulfilled" },
  { id: 7, value: "Close-No_Client_Response", label: "Close-No Client Response" },
  { id: 8, value: "Close-Unable_To_Fulfill", label: "Close-Unable To Fulfill" },
];
const allCurrency = [
  { id: 1, value: "INR", label: "INR" },
  { id: 2, value: "USD", label: "USD" },
  { id: 3, value: "GBP", label: "GBP" },
];
const budgetUOM = [
  { id: 1, value: "perHour", label: "Per Hour" },
  { id: 2, value: "perMonth", label: "Per Month" },
  { id: 3, value: "perDay", label: "Per Day" },
  { id: 4, value: "perYear", label: "Per Year" },
];